import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useObsWizard } from "@/features/obs/hooks/obs-wizard-context";

const SCALES = [
  { value: "1", label: "بدون تصغير (الوحدة الأساسية)" },
  { value: "1000", label: "ألف" },
  { value: "1000000", label: "مليون" },
  { value: "1000000000", label: "مليار" },
  { value: "1000000000000", label: "ترليون" },
];

/** Step 4 — declare what the numbers are in. Nothing in the file says. */
export function StepUnits() {
  const { draft, patch, goTo, needsWorkbookAgain } = useObsWizard();

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-amber-500/40 bg-amber-500/5 p-3 text-sm">
        لا يحتوي الملف على ما يدل على عملته أو مقياسه، فهذه القيم تُعلَن هنا ولا
        تُستنتج.
      </div>

      {needsWorkbookAgain ? (
        <div className="rounded-lg border border-red-500/40 bg-red-500/5 p-3 text-sm">
          <span className="font-semibold">الملف غير متاح الآن.</span> أُعيد فتح
          هذه المسودة لكن المتصفح لم يُعِد ملف Excel نفسه، ولم تُرفع بياناته بعد.
          كل ما أدخلته محفوظ —{" "}
          <button
            type="button"
            className="font-semibold underline underline-offset-4"
            onClick={() => goTo("file")}
          >
            ارجع إلى خطوة «الملف»
          </button>{" "}
          واختر الملف نفسه مرة أخرى للمتابعة.
        </div>
      ) : (
        <div className="rounded-lg border border-border bg-muted/30 p-3 text-sm text-muted-foreground">
          بعد هذه الخطوة سيُنشأ التقرير وتُرفع بياناته، ويبقى غير منشور حتى تختار
          الرسوم وتعاينه.
        </div>
      )}

      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label htmlFor="obs-unit-ar">العملة (عربي)</Label>
          <Input
            id="obs-unit-ar"
            value={draft.unitAr}
            onChange={(e) => patch({ unitAr: e.target.value })}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="obs-unit-en">العملة (إنجليزي)</Label>
          <Input
            id="obs-unit-en"
            dir="ltr"
            value={draft.unitEn}
            onChange={(e) => patch({ unitEn: e.target.value })}
          />
        </div>
        <div className="space-y-1.5">
          <Label>مقياس عرض الرسوم</Label>
          <Select
            value={draft.scale}
            onValueChange={(scale) => patch({ scale })}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {SCALES.map((s) => (
                <SelectItem key={s.value} value={s.value}>
                  {s.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="obs-multiplier">معامل ضرب القيم</Label>
          <Input
            id="obs-multiplier"
            dir="ltr"
            className="font-mono"
            value={draft.multiplier}
            onChange={(e) => patch({ multiplier: e.target.value })}
          />
          <p className="text-xs text-muted-foreground">
            إذا كان الملف يذكر الأرقام بالملايين ضع 1000000 — تُحفظ الأرقام كاملة
            دائمًا.
          </p>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="obs-scaleunit-ar">وحدة القياس (عربي)</Label>
          <Input
            id="obs-scaleunit-ar"
            value={draft.scaleUnitAr}
            onChange={(e) => patch({ scaleUnitAr: e.target.value })}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="obs-scaleunit-en">وحدة القياس (إنجليزي)</Label>
          <Input
            id="obs-scaleunit-en"
            dir="ltr"
            value={draft.scaleUnitEn}
            onChange={(e) => patch({ scaleUnitEn: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
}
